'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;

var _Popover2 = require('./Popover');

var _Popover3 = _interopRequireDefault(_Popover2);

var _PopoverAnimationVertical2 = require('./PopoverAnimationVertical');

var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Popover = _Popover3.default;
exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
exports.default = _Popover3.default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Popover/index.js
// module id = 861
// module chunks = 0